import React from "react";

export default function DateFilter({ column: { filterValue = [], preFilteredRows, setFilter, id } }) {
  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows && preFilteredRows.length > 0 ? new Date(preFilteredRows[0].values[id]) : new Date("1970-01-01");
    let max = preFilteredRows && preFilteredRows.length > 0 ? new Date(preFilteredRows[0].values[id]) : new Date("2050-12-31");

    preFilteredRows.forEach(row => {
      min = new Date(row.values[id]) <= min ? new Date(row.values[id]) : min;
      max = new Date(row.values[id]) >= max ? new Date(row.values[id]) : max;
    });

    return [min, max];
  }, [id, preFilteredRows]);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <input
        value={filterValue[0] || ""}
        type="date"
        min={min.toISOString().slice(0, 10)}
        onChange={e => {
          const val = e.target.value;
          setFilter((old = []) => [val ? (val) : undefined, old[1]]);
        }}
        style={{
          width: "170px",
          marginRight: "0.5rem"
        }}
      />
      to
      <input
        value={filterValue[1] || ""}
        type="date"
        max={max.toISOString().slice(0, 10)}
        onChange={e => {
          const val = e.target.value;
          setFilter((old = []) => [old[0], val ? (val) : undefined]);
        }}
        style={{
          width: "170px",
          marginLeft: "0.5rem"
        }}
      />
    </div>
  );
}
